import styled from 'styled-components';
import { propStyling } from '../../shared/propStyling';
import { tombac } from '../../shared/tombac';
export const Navbar = styled.div.attrs(() => ({
  className: 'TombacNavbar'
})).withConfig({
  displayName: "Navbar"
})(["align-items:center;background-color:", ";box-shadow:0 ", " 0 hsla(0,0%,0%,0.04);display:flex;min-height:", ";position:relative;@media (max-width:", "){min-height:", ";}", ""], tombac.color.white, tombac.unit(2, 8), tombac.space(10), _ref => {
  let {
    breakpoint = 768
  } = _ref;
  return tombac.unit(breakpoint);
}, tombac.space(8), propStyling);
//# sourceMappingURL=Navbar.js.map